import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService, HttpBaseService, LocalizationService, NotifyService } from '@app/core';
import { ApiControllerEnum } from '@app/shared/common/enums';
import { AvailabilityRuleListItem } from '../models/availability-rule/availability-rule-list-item';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AvailabilityRuleService extends HttpBaseService{

  constructor(private http: HttpClient
    , private notifyServ: NotifyService
    , private localizationService: LocalizationService
    , private configService: ConfigurationService) {
    super(http, ApiControllerEnum.AvailabilityRule, notifyServ, localizationService, configService);
  }

  getListByFilter(filter: any): Observable<AvailabilityRuleListItem[]> {
    return this.post("GetListByFilter", filter, true);
  }

  save(obj: AvailabilityRuleListItem): Observable<any> {
      return this.post("SaveAsync", obj, true);
  }
}